import AOS from 'aos';

import './utils/vh.utils.js';
import './utils/animate-on-view.utils';
import './utils/parallax-on-view.utils.js';

import './components/header.component.js';
import './components/uploadFile.component.js';
import './components/inputs.component.js';
import './components/meta-select.component.js';
import './components/meta/select.component.js';
import './components/content-sticky.component.js';
import './components/fit-tabs.component.js';

import './libs/countUp.lib.js';

import './components/animations.component.js';
import './components/text-sec-rows.component.js';
import './components/aura-cursor.component.js';

import './components/sw-insights.component.js';
import './components/sw-up-next.component.js';
import './components/sw-team.component.js';
import './components/sw-job-descr.component.js';
import './components/sw-innovation.component.js';
import './components/sw-brand-innovation.component.js';
import './components/sw-resources.component.js';

import './components/validation.component.js';

AOS.init();

document.querySelectorAll('.file-input').forEach(function (input) {
  input.addEventListener('change', function () {
    const fileNameElement = this.nextElementSibling.querySelector('.file-name');
    if (this.files.length > 0) {
      fileNameElement.textContent = this.files[0].name;
      fileNameElement.style.display = 'block';
    } else {
      fileNameElement.textContent = '';
      fileNameElement.style.display = 'none';
    }
  });
});



document.addEventListener('DOMContentLoaded', () => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isSafari) {
    document.documentElement.classList.add('safari-browser');
  }
});


const tiltElements = document.querySelectorAll(".js-tilt");

if (tiltElements.length > 0 && window.innerWidth > 1365) {
  VanillaTilt.init(tiltElements, {
    max: 15,
    speed: 1000,
    reset: true,
    transition: true,
    "reset-to-start": true,
    easing: "cubic-bezier(.03,.98,.52,.99)",
    glare: true,
    "max-glare": .3,
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.innovation-sec__tab');
  const tabInfos = document.querySelectorAll('.innovation-sec__tabs-info');

  if (tabs.length && !document.querySelector('.innovation-sec__tab.active')) {
    tabs[0].classList.add('active');
  }
  if (tabInfos.length && !document.querySelector('.innovation-sec__tabs-info.active')) {
    tabInfos[0].classList.add('active');
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tabInfos.forEach(info => info.classList.remove('active'));

      tab.classList.add('active');
      tabInfos[index].classList.add('active');
    });
  });
});

